export const DATE_TYPE_URI = 'urn:replicon:custom-field-type:date';

export const DROP_DOWN_TYPE_URI = 'urn:replicon:custom-field-type:drop-down';

export const NUMERIC_TYPE_URI = 'urn:replicon:custom-field-type:numeric';

export const TEXT_TYPE_URI = 'urn:replicon:custom-field-type:text';
